'use client'

import { Button, Card, Chip, Text } from '@vinted/web-ui'
import { FormEvent, useState } from 'react'

import {
  postHomepageAction,
  userHomepageElementsSelectionAction,
  ElementsSelectionModel,
} from '@marketplace-web/home/home-page-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

import HomepageBlockLayout from '../Layouts/HomepageBlockLayout'
import PostAction from './PostAction'

type Props = ElementsSelectionModel & {
  homepageSessionId: string
  position: number
}

const ElementsSelection = (props: Props) => {
  const { track } = useTracking()
  const breakpoints = useBreakpoint()
  const [selectedElementIds, setSelectedElementIds] = useState<Array<string>>([])
  const [isSubmitted, setIsSubmitted] = useState(false)

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault()
    setIsSubmitted(true)

    postHomepageAction({
      blockName: props.name,
      payload: selectedElementIds,
    })

    track(
      userHomepageElementsSelectionAction({
        homepageSessionId: props.homepageSessionId,
        blockName: props.name,
        elements: props.elements.reduce(
          (acc, element) => ({ ...acc, [element.id]: selectedElementIds.includes(element.id) }),
          {},
        ),
      }),
    )
  }

  if (isSubmitted) return <PostAction {...props.postAction} />

  return (
    <HomepageBlockLayout {...props}>
      <Card>
        <form onSubmit={handleSubmit} className="homepage-element-selection">
          <div className="homepage-element-selection__content">
            <Text type={Text.Type.Heading} as="h2" text={props.title} />
            <Text as="p" text={props.subtitle} />
            <ul className="homepage-element-selection__list">
              {props.elements.map((element, index) => (
                <li key={index}>
                  <Chip
                    text={element.title}
                    textType={Text.Type.Subtitle}
                    activated={selectedElementIds.includes(element.id)}
                    onClick={() => {
                      setSelectedElementIds(prev =>
                        prev.includes(element.id)
                          ? prev.filter(id => id !== element.id)
                          : [...prev, element.id],
                      )
                    }}
                    type="button"
                  />
                </li>
              ))}
            </ul>
          </div>
          <Button
            type={Button.Type.Submit}
            styling={Button.Styling.Filled}
            disabled={selectedElementIds.length === 0}
            text={props.actionTitle}
            inline={breakpoints.desktops}
          />
        </form>
      </Card>
    </HomepageBlockLayout>
  )
}

export default ElementsSelection
